import { ETH } from '../types';
export default {
  type: ETH,
  service: 'myetherwallet.com',
  url: 'https://api.myetherwallet.com/eth',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
